import type { Device } from "@tandemdiabetes/sugarmate-api-react-client"
import { useGetDevice } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import type { SWRResponse } from "swr"
import useSWR from "swr"

import { useDeviceSWRKey } from "./useDeviceSWRKey"

export function useDevice(): SWRResponse<Device> {
  const deviceSWRKey = useDeviceSWRKey()
  const getDevice = useGetDevice()

  const getDeviceData = useMemo(
    () => !getDevice ? null : (async () => {
      const response = await getDevice()
      return response.data.device
    }),
    [getDevice],
  )

  return useSWR<Device>(
    deviceSWRKey,
    getDeviceData,
  )
}
